// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2466":"5fa8d789","6669":"a5af641a","8544":"29c38d54","9146":"a5af641a","9195":"a5af641a"}[chunkId] + ".chunk.css";
};